export const FORM_STATES = {
	LOADING: 'LOADING',
	FORM: 'FORM',
	ERROR: 'ERROR'
};

export const ERRORS = {
	LLS: 'LLS',
	DOWNLOAD: 'DOWNLOAD',
	GENERAL: 'GENERAL'
};

export const IDENTITY_TYPES = {
	IDENTITY_CARD: 'IDENTITY_CARD',
	PASSPORT: 'IDENTITY_CARD',
	DRIVING_LICENSE: 'IDENTITY_CARD'
};
